import styles from './ProstheticsDesc.module.scss';
import { Stack } from '../../../shared/ui/Stack/Stack';
import { Text } from '../../../shared/ui/Text/Text';

const ProstheticsDesc = () => {
    return ( 
        <div>
        <div className={styles.container}>
            <Stack
                direction = 'column'
                gap = '32'
                justifyContent='justifyCenter'
                alignItems ='alignCenter'
                className={styles.content}>
                <Text
                    size ='m'
                    className={styles.title}>
                        Как проходит ортопедическое лечение в нашей клинике
                </Text>
                <Text
                    size ='m'
                    className={styles.text}>
                        Врач-стоматолог-ортопед проводит клиническое обследование с 
                        рентгенограммами. Оценивает пригодность для коронок и дает 
                        рекомендации  по выбору материалов, последовательности лечения
                        и любым другим вопросам, которые могут у вас возникнуть.
                </Text>
                <Text
                    size ='m'
                    className={styles.text}>
                        На втором этапе зубы, подлежащие протезированию, подготавливаются. 
                        Это включает в себя уменьшение размера зуба, под местной анестезией,  
                        с последующим снятием слепков.  Затем слепки отправляется в лабораторию, 
                        где опытные специалисты изготовят коронку. Тем временем изготавливается 
                        временная коронка и устанавливается на обточенный зуб.
                </Text>
                <Text
                    size ='m'
                    className={styles.text}>
                        На третьем этапе временная коронка снимается, поверхности зуба 
                        очищаются. Готовая коронка примеряется к зубу для проверки 
                        посадки, соответствия прикусу и внешнего вида. Наконец, коронка 
                        фиксируется на подготовленном зубе с помощью стоматологического 
                        цемента.
                </Text>
            </Stack>
        </div>
        <Stack
                direction = 'column'
                gap = '32'
                justifyContent='justifyCenter'
                alignItems ='alignCenter'
                className={styles.content}>
                <Text
                    size ='m'
                    className={styles.title}>
                        Срок службы зубных протезов
                </Text>
                <Text
                    size ='m'
                    className={styles.text}>
                        Зависит от вида протеза, материала из которого он изготовлен и последующей эксплуатации.
                        Коронки изготавливаются из инертных материалов, которые не разрушаются 
                        со временем. Однако зуб под ними все равно подвержен кариесу и 
                        заболеваниям десен. 
                        Основной фактор, влияющий на то как долго будет служить протез  это - гигиена. Ежедневная чистка зубов и использование 
                        зубной нити необходимы для поддержания здоровья полости рта. 
                        Также керамика на поверхности может отколоться или сломаться. Избегайте жевания слишком твердых веществ. 
                </Text>
                <Text
                    size ='m'
                    className={styles.text}>
                        Регулярные осмотры позволят во время обнаружить любые проблемы с 
                        коронкой и порекомендовать необходимое лечение.
                </Text>
                <Text
                    size ='m'
                    className={styles.text}>
                        В нашей клинике вы получите необходимую консультацию врача стоматолога-ортопеда, 
                        который  подберет подходящий именно вам протез, с учетом ваших пожеланий и 
                        выполнит необходимое комплексное лечение. Все процедуры, связанные с обработкой 
                        зубов для установки протезов, проводятся с использованием анестезии, что позволяет 
                        избежать боли и дискомфорта.
                </Text>
            </Stack>
        </div>
    );
}

export default ProstheticsDesc;